import React, { useContext, useEffect } from "react";
import { FadeIn } from "react-lazyload-fadein";
import { useNavigate, Navigate, useParams } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../App";
import SimulatorHeader from "../../components/simulator-header/SimulatorHeader";
import styles from "./EnvironmentVariation.styles.scss";

import { Tag } from "../../components/tag/Tag";
import { FeaturedTag } from "../../components/featuredTag/FeaturedTag";
import TagManager from 'react-gtm-module';

const EnvironmentVariation = () => {
    const navigate = useNavigate();
    const { environment: environmentParams } = useParams()
    const {
        environment,
        setEnvironment,
    } = useContext(UserContext);

    useEffect(() => {
        const getData = async () => {
            await axios
                .get(`${MIX_URL}/simulator-api/environments`)
                .then((response) => {
                    const result = response?.data?.environments
                    const environmentData = result?.find((item) => item?.slug === environmentParams);

                    if (environmentData) setEnvironment(environmentData);
                })
                .catch((err) => {
                    console.log(err);
                    setEnvironment(null);
                    navigate("/escolha-um-ambiente");
                    navigate(0);
                });
        }

        if (environment === null && !environmentParams) {
            setEnvironment(null);
            navigate("/escolha-um-ambiente");
            navigate(0);
            console.log('Ambiente não selecionado');
        }

        if (environment === null) {
            getData();
        }
    }, []);

    return (
        <>
            {environment !== null ? <Content /> : <></>}
        </>
    )
}

const Content = () => {
    const {
        environment,
        envVariation,
        setEnvVariation,
        setStep,
        isTotem,
    } = useContext(UserContext);

    const navigate = useNavigate();

    const setEnv = (envOption) => {
        setEnvVariation(envOption);
        const totemInfo = isTotem ? "totem_" : "";

        const event = {
            event: 'click',
            eventCategory: 'click',
            eventAction: totemInfo + `simulador_passo_02_click_${envOption.slug}`
        };

        TagManager.dataLayer({ dataLayer: event });

        navigate(`/${environment.slug}/${envOption.slug}/selecione-um-padrao`);
    };

    const envVariations = environment?.environment_options || [];

    useEffect(() => {
        setStep(2);
    }, [envVariations]);

    return (
        <div className={`env-variation-page ${isTotem ? "totem" : ""}`}>
            <div className="container m-auto">
                <SimulatorHeader
                    title="2. Selecione uma opção de ambiente"
                    prev="/escolha-um-ambiente"
                    nextHidden
                />
                <div className="templates grid grid-cols-2 md:grid-cols-2 gap-20 pb-80">
                    {envVariations.map((env) => (
                        <div className="image-container" key={env.slug}>
                            <a
                                className="image-link relative"
                                onClick={() => setEnv(env)}
                            >
                                <img
                                    src={`${MIX_URL}/front-end/img/loading.gif`}
                                    alt="Loading"
                                    className="h-200 w-auto loading"
                                />
                                <FadeIn easing="ease-in-out">
                                    {(onload) => (
                                        <img
                                            src={`${MIX_AWS_URL}/${env.selection_image}`}
                                            onLoad={onload}
                                            onError={onload}
                                        />
                                    )}
                                </FadeIn>
                                <div className="flex z-1 flex-col space-y-10 absolute bottom-40">
                                    <Tag label="Portfólio Duratex" />
                                    {
                                        env.has_duratex_you_patterns && <FeaturedTag label="Duratex YOU" />
                                    }
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EnvironmentVariation;
